import { render, staticRenderFns } from "./EditPersonPhoneNumberDialog.vue?vue&type=template&id=e5d2563e&scoped=true&"
import script from "./EditPersonPhoneNumberDialog.vue?vue&type=script&lang=js&"
export * from "./EditPersonPhoneNumberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d2563e",
  null
  
)

export default component.exports